import { SET_ACTIVE_THREAD } from "./ActiveThreadType";

export const setActiveThread = (thread) => ({
  type: SET_ACTIVE_THREAD,
  payload: thread,
});